// FilterApi.js
import { api } from "./Apiwithouttoken";

export const getDefaultFilters = () => ({
  priceRange: { min: 1, max: 10000 }, // Changed from 1000 to 10000
  amenities: { bedroom: 0, bathroom: 0, bed: 0 },
  propertyType: null,
  instantBook: false,
  allowPets: false
});

export const applyFilters = async (
  properties,
  filterParams,
  onSuccess,
  setLoading,
  setOpenFilter
) => {
  try {
    console.log('=== FILTER API DEBUG ===');
    console.log('Properties count:', properties.length);
    console.log('Filter params:', filterParams);
    console.log('Backend URL:', process.env.REACT_APP_BACKEND_SERVER);
    
    // Always send to backend for consistent filtering
    const filterData = {
      priceRange: filterParams.range,
      amenities: filterParams.amenities,
      propertyType: filterParams.propertyType,
      instantBook: filterParams.instantBook,
      allowPets: filterParams.allowPets,
      guests: filterParams.guests,
      period: filterParams.reservation_period,
      specificAmenities: filterParams.metaDetails.amenities
    };

    console.log('Sending filter request to backend:', JSON.stringify(filterData, null, 2));
    
    const backendResults = await api("property/filterProperties", filterData);
    
    console.log('Backend filter response type:', typeof backendResults);
    console.log('Backend filter response:', backendResults);
    
    if (Array.isArray(backendResults)) {
      console.log('Backend returned array with', backendResults.length, 'properties');
      onSuccess(backendResults);
    } else {
      console.warn('Backend returned non-array result:', backendResults);
      // Fallback to local filtering if backend fails
      console.log('Falling back to local filtering...');
      let filteredResults = properties.filter(property => {
        const price = property.short?.price_per_day || 0;
        return price >= filterParams.range.min && price <= filterParams.range.max;
      });
      console.log('Local filtering returned', filteredResults.length, 'properties');
      onSuccess(filteredResults);
    }
    
    setOpenFilter(false);
  } catch (error) {
    console.error("=== FILTER API ERROR ===");
    console.error("Error details:", error);
    console.error("Error message:", error.message);
    console.error("Error stack:", error.stack);
    
    // Fallback to local filtering on error
    console.log('Falling back to local filtering due to error');
    let filteredResults = properties.filter(property => {
      const price = property.short?.price_per_day || 0;
      return price >= filterParams.range.min && price <= filterParams.range.max;
    });
    console.log('Local filtering returned', filteredResults.length, 'properties');
    onSuccess(filteredResults);
  } finally {
    setLoading(false);
  }
};

// NEW: Unified filtering and sorting function
export const getFilteredAndSortedProperties = async (
  filterParams,
  sortType = "newest",
  onSuccess,
  setLoading,
  setOpenFilter
) => {
  try {
    console.log('=== UNIFIED FILTER & SORT API DEBUG ===');
    console.log('Filter params:', filterParams);
    console.log('Sort type:', sortType);
    
    // Build unified request payload
    const unifiedRequest = {
      // Filter parameters
      priceRange: filterParams.range,
      amenities: filterParams.amenities,
      propertyType: filterParams.propertyType,
      instantBook: filterParams.instantBook,
      allowPets: filterParams.allowPets,
      guests: filterParams.guests,
      period: filterParams.reservation_period,
      specificAmenities: filterParams.metaDetails?.amenities || {},
      
      // Sort parameter
      sortBy: sortType,
      
      // Pagination
      limit: 50,
      skip: 0
    };

    console.log('Sending unified request to backend:', JSON.stringify(unifiedRequest, null, 2));
    
    // Call the new unified endpoint
    const response = await api("property/getFilteredAndSortedProperties", unifiedRequest);
    
    console.log('Unified API response:', response);
    
    if (response && Array.isArray(response.properties)) {
      console.log('Unified API returned', response.properties.length, 'properties');
      console.log('Total count:', response.totalCount);
      console.log('Has more:', response.hasMore);
      
      // Pass the filtered and sorted properties to the callback
      onSuccess(response.properties);
      
      // Return additional metadata for pagination if needed
      return {
        properties: response.properties,
        totalCount: response.totalCount,
        hasMore: response.hasMore,
        currentPage: response.currentPage,
        totalPages: response.totalPages
      };
    } else {
      console.warn('Unified API returned unexpected format:', response);
      throw new Error('Invalid response format from unified API');
    }
    
    setOpenFilter(false);
  } catch (error) {
    console.error("=== UNIFIED FILTER & SORT API ERROR ===");
    console.error('Error details:', error);
    
    // Fallback to local filtering if backend fails
    console.log('Falling back to local filtering...');
    let filteredResults = filterParams.properties?.filter(property => {
      const price = property.short?.price_per_day || 0;
      return price >= filterParams.range.min && price <= filterParams.range.max;
    }) || [];
    
    console.log('Local filtering returned', filteredResults.length, 'properties');
    onSuccess(filteredResults);
    
    throw error;
  }
};